import { Component } from '@angular/core';

@Component({
  selector: 'app-property-welcome',
  templateUrl: './property-welcome.component.html',
  styleUrls: ['./property-welcome.component.scss']
})
export class PropertyWelcomeComponent {

}
